import { render, staticRenderFns } from "./open-api-doc.vue?vue&type=template&id=650be8a0"
import script from "./open-api-doc.vue?vue&type=script&lang=js"
export * from "./open-api-doc.vue?vue&type=script&lang=js"
import style0 from "./open-api-doc.vue?vue&type=style&index=0&id=650be8a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports